import { Company } from './Company'

export class DemandRegion {
	public id: number
	public name: string
		public company?: Company
}
